import {React, observer} from '@api'
import {Icon} from '@blueprintjs/core'
import {Tooltip2} from '@api'
import { useCatalog} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'

export const ShowOnlyExpandedCardsToolbarButton = observer(() => {
  const {strings, toggleShowOnlyInlineCatalogItems, hasExpandedCatalogItems, settings: {showOnlyInlineCatalogItems}} = useCatalog()
  return (
      <PrimaryIconButton
        tooltip={strings.showOnlyExpandedCards}
        onClick={toggleShowOnlyInlineCatalogItems}
        disabled={!hasExpandedCatalogItems}
        active={showOnlyInlineCatalogItems}>
        <Icon icon='eye-open'/>
      </PrimaryIconButton>
  )
})

export const ShowExpandedCardsFirstToolbarButton = observer(() => {
  const {strings, toggleShowInlineItemsFirst, hasExpandedCatalogItems, settings: {showInlineCatalogItemsFirst, levelOfDetail}} = useCatalog()
  return (levelOfDetail === 1 || !hasExpandedCatalogItems ? null :
      <PrimaryIconButton
        onClick={toggleShowInlineItemsFirst}
        tooltip={strings.showExpandedCardsFirst}
        disabled={!hasExpandedCatalogItems}
        active={showInlineCatalogItemsFirst}>
        <Icon icon={showInlineCatalogItemsFirst ? 'unpin' : 'pin'}/>
      </PrimaryIconButton>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/ShowOnlyExpandedCardsToolbarButton.tsx